<app-template-number
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [required]="required"
  [disabled]="disabled"
  [control]="control"
  [commas]="commas"
  [label]="label"
/>
